export class UnifiedRestoreMicrosoft365Request {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<UnifiedRestoreMicrosoft365User>",
            "format": ""
        },
        {
            "name": "skipDataWhenRecoveredFromRecycleBin",
            "baseName": "skipDataWhenRecoveredFromRecycleBin",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedRestoreMicrosoft365Request.attributeTypeMap;
    }
    constructor() {
    }
}
